interface SkeletonLoaderProps {
  count?: number;
  className?: string;
}

const SkeletonLoader = ({ count = 3, className = '' }: SkeletonLoaderProps) => (
  <div className={`animate-pulse space-y-4 ${className}`} role="status" aria-label="Loading content">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-gray-200 dark:bg-gray-700 rounded h-20 w-full" />
    ))}
    <span className="sr-only">Loading...</span>
  </div>
);

export default SkeletonLoader;
